import { IconButton, styled, Typography } from '@mui/material';

export const ContainerW = styled('div')`
  width: 100%;
  border-radius: 15px;
  padding: 24px 0px 16px 0px;
  position: relative;

  @media (max-width: 1023px) {
    padding: 0px 16px;
    width: 100%;
  }
`;

export const DaysW = styled('div')``;

export const HeaderW = styled('div')`
  display: flex;
  align-items: center;
`;

export const IconButtonW = styled(IconButton, {
  shouldForwardProp: (propname) => propname !== 'isActive',
})<{ isActive: boolean }>(({ isActive, theme }) => ({
  fontWeight: '500',
  fontSize: '16px',
  lineHeight: '16px',
  width: '26px',
  height: '26px',
  color: isActive ? theme.palette.primary.p080 : theme.palette.primary.p040,
}));

export const Title = styled(Typography)`
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  text-transform: none;
  margin-right: 8px;
`;

export const CalendarLink = styled('a')`
  position: absolute;
  bottom: 0px;
  right: 17px;
  font-size: 14px;
`;

export const SectionTitle = styled(Typography)`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;

  @media (max-width: 1023px) {
    display: none;
  }
`;

export const TitleRow = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const OpenCalendarButton = styled('a')`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px;
  height: 56px;
  width: 182px;
  border: 1px solid ${({ theme }) => theme.palette.primary.grey};
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.white.main};
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.secondary.dark};
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: ${({ theme }) => theme.palette.white.p100};
  }

  @media (max-width: 1023px) {
    width: 100%;
    justify-content: center;
  }
`;

export const InnerContainer = styled('div')`
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  background: ${({ theme }) => theme.palette.white.main};
  margin-top: 40px;
  border-radius: 8px;
  width: 100%;
  height: 100%;
  padding: 16px;
`;
